<template>
  <EDialog
    :dialog-title="dialogTitle"
    :center-dialog-visible="visible"
    :popup-width="'800px'"
    :show-btn="false"
    :show-close-btn="true"
    @resetPopupData="resetPopupData"
  >
    <div class="checkRole">
      <eTableList
        :table-data="tableList"
        :table-label="tableLabel"
        max-height="390"
      >
        <template #indexSlot="slot">
          <div class="flex-center-center">{{ slot.scope.$index + 1 }}</div>
        </template>
      </eTableList>
      <!-- <div class="pagination">
        <el-pagination
          :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
          layout="prev, pager, next, jumper"
          :current-page="productTagPage.pageNum"
          :page-size="productTagPage.pageSize"
          :total="productTagPage.pageTotal"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div> -->
    </div>
  </EDialog>
</template>

<script>
import EDialog from '@/modules/projectA/components/common/e-dialog';
import eTableList from '@/modules/projectA/components/common/e-table-list';
// import Api from '../../../api/authority/index';

export default {
  name: 'ViewRoleDialog',
  components: {
    EDialog,
    eTableList,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    tableList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      dialogTitle: '查看明细',
      authTree: [],
      defaultProps: {
        children: 'childList',
        label: 'authName',
      },
      productTagPage: {
        pageNum: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      tableLabel: [
        { label: '角色名称', param: 'roleName', align: 'center', width: '200' },
        {
          label: '角色描述',
          param: 'remark',
          align: 'center',
          tooltip: true,
        },
      ],
    };
  },
  computed: {},
  created() {},
  methods: {
    resetPopupData() {
      this.$emit('close');
    },
    getList() {},
    submitPopupData() {},
    // 更改页码
    handleCurrentChange(val) {
      this.productTagPage.pageNum = val;
      this.getList();
    },

    // 更改条数
    handleSizeChange(val) {
      this.productTagPage.pageNum = 1;
      this.productTagPage.pageSize = val;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.checkRole {
  .pagination {
    text-align: center;
  }
}
</style>
